import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { connect } from "react-redux";
import { addMusicServiceLink } from 'redux/music-links/actions';

import { Field, reduxForm, formValueSelector } from 'redux-form';
import { Form } from 'semantic-ui-react';

import Parser from 'html-react-parser';

import CommonSearchDropdownSelector
  from 'components/common/CommonSearchDropdownSelector';
import TextField from 'components/redux-form-adapters/TextField';
import Button from 'components/elements/buttons/Button';
import CommonMessage from 'components/common/CommonMessage';

import validate from './validate';
import { fixURL } from 'utils/fixURL';

import './AddMusicServiceItemForm.css';


function AddMusicServiceItemForm(props) {
  const {
    handleSubmit,
    addMusicServiceLink,
    item,
    musicLinksList,
    addMusicServiceLinkError,
    url,
    reset,
    valid,
  } = props;

  const [selectedService, setSelectedService] = useState(null);

  const { t } = useTranslation();

  const itemsList = musicLinksList.services ? Object.keys(musicLinksList.services).map(key => ({
    id: musicLinksList.services[key].id,
    name: musicLinksList.services[key].title,
    icon_svg: musicLinksList.services[key].icon_svg,
  })) : null;

  const _handleSubmit = values => {
    const urlValue = fixURL(values.url);

    addMusicServiceLink({
      url: urlValue,
      music_link: item.id,
      music_service: selectedService.id,
    });
    reset();
  };

  return (
    <div className="add-music-service-item-form__component">
      <Form
        onSubmit={handleSubmit(_handleSubmit)}
        error={!valid}
      >
        <div className="music-service-selector-wrapper">
          <CommonSearchDropdownSelector
            setSelectedItem={setSelectedService}
            itemsList={itemsList}
            searchPlaceholder={t("Select Music Service")}
          />
          <Button
            small
            submit
            disabled={!selectedService || !url || !valid}
          >
            {t("Add Store")}
          </Button>
        </div>

        {selectedService &&
          <div className="field-wrapper">
            <div className="service-icon">
              {Parser(selectedService.icon_svg)}
            </div>
            <Field
              component={TextField}
              name="url"
              type="text"
              placeholder={t("Paste your link here")}
              required
            />
          </div>
        }
      </Form>

      {addMusicServiceLinkError &&
        <CommonMessage
          error
          errors={addMusicServiceLinkError}
        />
      }

    </div>
  );
}

AddMusicServiceItemForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  addMusicServiceLink: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  musicLinksList: PropTypes.object,
  addMusicServiceLinkError: PropTypes.object,
  url: PropTypes.string,
  valid: PropTypes.bool,
};

AddMusicServiceItemForm.defaultProps = {
  musicLinksList: null,
  addMusicServiceLinkError: null,
  url: null,
  valid: null,
};


const mapStateToProps = (state) => {
  const selector = formValueSelector('AddMusicServiceItemForm');
  return {
    url: selector(state, 'url'),
    musicLinksList: state.musicLinksReducer.musicLinksList,
    addMusicServiceLinkError: state.musicLinksReducer.addMusicServiceLinkError,
  };
};

export default connect(
  mapStateToProps,
  {
    addMusicServiceLink
  },
)(reduxForm({
  form: 'AddMusicServiceItemForm',
  validate,
})(AddMusicServiceItemForm));